const dateJs = require('@/assets/js/date.js').default
const messageConfig = require("@/models/messageConfig")
const validformrequire = messageConfig.getMessage("validformrequire")
const errornumber = messageConfig.getMessage("errornumber")
const validation = require("@/assets/js/validation.js").default
const convertDecimal = require("@/assets/js/convert").convertDecimal
const useAuthority = require("@/store/authority").useAuthorityStore()

// 上画日期非空验证
const postDateValidation = (rule, value, callback, source) => {
  return (source.postDateType === 'StartFrom' && (value ?? '') !== '') || source.postDateType !== 'StartFrom'
}
// 下画日期非空验证
const depostDateValidation = (rule, value, callback, source) => {
  return (source.depostDateType === 'DepostOnOrBefore' && (value ?? '') !== '') || source.depostDateType !== 'DepostOnOrBefore'
}

module.exports = {
  OperationRules: {
    postDateType: {
      required: true,
      message: validformrequire
    },
    depostDateType: {
      required: true,
      message: validformrequire
    },
    postDate: [{
      message: validformrequire,
      validator: postDateValidation
    }, {
      message: messageConfig.getMessage("postgtdate"),
      validator (rule, value, callback, source) {
        if (source.postDateType !== "StartFrom") {
          return true;
        }
        return source.postDateType === "StartFrom"
      }
    }],
    depostDate: [{
      message: validformrequire,
      validator: depostDateValidation
    }, {
      message: messageConfig.getMessage("depostltdate"),
      validator (rule, value, callbakc, source) {
        if (source.depostDateType !== "DepostOnOrBefore") {
          return true;
        }
        return source.depostDateType === "DepostOnOrBefore"
      }
    }],
  },
  ProductionChangeRules: {
    productionDate: {
      required: true,
      message: validformrequire
    },
    productionCostType: {
      required: true,
      message: validformrequire
    },
    salesAmount: [{
      required: true,
      message: validformrequire,
      validator (rule, value) {
        if (!useAuthority.bHasRole("BBSalesman")) {
          return true;
        }

        return (value || "") !== "" || value === "0"
      }
    }, {
      message: errornumber,
      validator (rule, value) {
        if (!useAuthority.bHasRole("BBSalesman")) {
          return true;
        }
        return validation.NumberValidate(value) && value !== "0" && value !== 0
      }
    }, {
      message: messageConfig.getMessage("insufficientbalance"),
      validator (rule, value, callback, source) {
        if (!useAuthority.bHasRole("BBSalesman")) {
          return true;
        }

        if ((source.action || "") !== "save") {
          return true
        }

        const numberJs = require("@/assets/js/numberjs")
        return numberJs.Subtraction(source.remainingBalance, value) >= 0
      }
    }],
    salesAdminAmount: [{
      required: true,
      message: validformrequire,
      validator (rule, value) {
        if (!useAuthority.isOrderTop()) {
          return true;
        }

        return (value || "") !== "" || value === "0"
      }
    }, {
      message: errornumber,
      validator (rule, value) {
        if (!useAuthority.isOrderTop()) {
          return true;
        }
        return validation.NumberValidate(value) && value !== "0" && value !== 0
      }
    }, {
      message: messageConfig.getMessage("insufficientbalance"),
      validator (rule, value, callback, source) {
        if (!useAuthority.isOrderTop()) {
          return true;
        }

        if ((source.action || "") !== "save") {
          return true
        }

        const numberJs = require("@/assets/js/numberjs")
        return numberJs.Subtraction(source.remainingBalance, value) >= 0
      }
    }],
  }
}
